import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { login } from "../redux/authSlice"; // Import Redux action
import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/apiConfig";
import { showToast } from "./ToastNotification";
import { Link } from "react-router-dom";
import "./Login.css";
import loginImg from "./../assets/images/login.jpg";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";


const Login = () => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({ email: "", password: "" });
    const navigate = useNavigate();  // Inside Login Component

    const [showPassword, setShowPassword] = useState(false);


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axiosInstance.post(API_ENDPOINTS.LOGIN, formData);
            console.log("Response from backend:", response.data);
            const { jwtToken, refreshToken, user } = response.data;
            console.log("response data ::: ", response.data)
            dispatch(login({ jwtToken, refreshToken, user })); // ✅ Update Redux Store
            showToast(`Welcome, ${user.firstName}!`, "success");

            navigate("/");
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Login failed. Please try again.";
            showToast(errorMessage, "error");
        }
    };

    return (
        <div className="container" style={{ marginTop: "4rem" }}>
            <div className="row">
                <div className="col-md-6 left-section">
                    <img src={loginImg} alt="Digital Product" className="responsive-image" />
                </div>

                <div className="col-md-6 right-section">
                    <div className="form-box">
                        <h2>Login</h2>
                        <form onSubmit={handleSubmit}>
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                className="form-control mb-2"
                                onChange={handleChange}
                                required
                            />
                            {/* Password Field with Eye Icon */}
                            <div className="password-container position-relative">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder="Password"
                                    className="form-control mb-2"
                                    onChange={handleChange}
                                    required
                                />
                                <span
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="password-toggle-icon"
                                    style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "#666",
                                    }}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                                </div >
                                <button type="submit" className="btn btn-primary w-100">Sign In</button>
                        </form>

                        <p className="register-link">
                            Don't have an account?
                            <Link to="/register">Register here</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
